import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAppContext } from '../libs/contextLib';

function querystring(name, url = window.location.href) {
  const encodedName = name.replace(/[[]]/g, '\\$&');

  const regex = new RegExp(`[?&]${encodedName}(=([^&#]*)|&|#|$)`, 'i');
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export default function UnauthenticatedRoute({ children, ...rest }) {
  const { user } = useAppContext();
  const redirect = querystring('redirect') || localStorage.getItem('lwd-userRedirect');
  return (
    <Route {...rest}>
      {!user.isAuthenticated ? (
        children
      ) : (
        <Redirect to={redirect === '' || redirect === null ? '/' : redirect} />
      )}
    </Route>
  );
}

UnauthenticatedRoute.propTypes = {
  children: PropTypes.object.isRequired,
};
